import { useNavigate } from "react-router-dom";
import React from "react";
import OwlCarousel from 'react-owl-carousel3';
import "./NewsRoom.css";
import { SupplierCenteralHeader } from "../Header";
import { SupplierCenteralFooter } from "../Footer";

export { NewsRoomDetails };

function NewsRoomDetails() {

  return (
    <div>
      {/* HEADER SEC */}
      <SupplierCenteralHeader />
      {/* HEADER SEC */}

      <div className="news-room-body d-flex">
        <div className="news-info-sec">
          <OwlCarousel className="news-hero-slider owl-theme" loop margin={10} nav dots={false} items={1} autoplay={false} autoplayHoverPause={false} smartSpeed={1500} autoplayTimeout={2500}>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-1.jpeg" alt="" />
              </div>
            </div>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-2.jpeg" alt="" />
              </div>
            </div>
            <div className="news-slider-item">
              <div className="news-hero-img">
                <img src="/images/news-img-3.jpeg" alt="" />
              </div>
            </div>
          </OwlCarousel>

          <div className="news-details-info">
            <div className="news-details-top-info">
              <div className="news-details-top-left">
                <div className="news-category-name"><span className="material-symbols-outlined">ballot</span> Relevant to Coles Liquor</div>
                <div className="news-d-title">Have you ever tasted bourbon straight from the barrel?</div>
                <div className="news-d-p">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae.</div>
                <div className="news-ul">
                  <div className="news-li"><span className="material-symbols-outlined">person</span> Helena Thomton</div>
                  <div className="news-li"><span className="material-symbols-outlined">event_available</span> 04/08/2024</div>
                  <div className="news-li"><span className="material-symbols-outlined">visibility</span> 240 Views</div>
                </div>
              </div>
              <div className="news-details-top-right">
                <button type="button" className="news-favorite-btn"><span className="material-symbols-outlined">favorite</span> Add to Favorites</button>
              </div>
            </div>

            <div className="news-details-bottom-info">
              <div className="news-d-p">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae.</div>
              <div className="news-d-p">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae.</div>
              <div className="news-d-p">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae.</div>

              <div className="news-d-video-sec">
                <div className="news-d-video-box">
                  <iframe width="100%" height="400" src="https://www.youtube.com/embed/Mh4f9AYRCZY?si=rFGcnOoaMHCJzJIW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div className="news-d-video-box">
                  <iframe width="100%" height="400" src="https://www.youtube.com/embed/Mh4f9AYRCZY?si=rFGcnOoaMHCJzJIW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>

              <ul className="some-list">
                <li><span className="material-symbols-outlined">check_circle</span> Have you ever tasted bourbon straight from the barrel?</li>
                <li><span className="material-symbols-outlined">check_circle</span> Have you ever tasted bourbon?</li>
                <li><span className="material-symbols-outlined">check_circle</span> Have you ever tasted bourbon straight from?</li>
                <li><span className="material-symbols-outlined">check_circle</span> Have you ever tasted bourbon from the barrel?</li>
              </ul>

            </div>
          </div>

        </div>
      </div>

      <SupplierCenteralFooter />
    </div>
  );
}